import React from 'react';
import type { FC } from 'react';
import {
  Typography,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: '3.213px',
    marginLeft: '40px',
    textTransform: 'uppercase',
    fontSize: '16px',
    lineHeight: 1,
    verticalAlign: 'middle'
  }
}));

const AppTitle: FC = () => {
  const classes = useStyles();

  return (
    <Typography
      classes={{
        root: classes.root
      }}
    >
      Входной контроль
    </Typography>
  );
};

export default AppTitle;
